import { useEffect } from 'react';

// Custom hook pro odchycení tlačítka zpět v browseru (pro možnou navigaci v kalkulaci)
export const useInterceptBrowserBackButton = (isPhaseMode, isDietModeAndFirstPhase, setPrevPhase, resetPhaseStep) => {
    const onBackButtonPressed = () => {
        if (isPhaseMode || isDietModeAndFirstPhase) {
            history.back();
        } else {
            setPrevPhase();
            resetPhaseStep();
        }
    };

    useEffect(() => {
        const popStateListener = () => {
            onBackButtonPressed();
            // @todo checknout, jestli je potřeba
            // history.pushState(null, null, window.location.pathname);
        };

        window.addEventListener('popstate', popStateListener);

        return () => {
            window.removeEventListener('popstate', popStateListener);
        };
    }, [isPhaseMode, isDietModeAndFirstPhase]);
};
